import React from 'react';
import PropTypes from 'prop-types'; // eslint-disable-line import/no-extraneous-dependencies

const Row = ({ children, className }) => (
  <div className={`Row ${className}`}>
    {children}
  </div>
);

Row.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  className: PropTypes.string,
};

Row.defaultProps = {
  children: [],
  className: '',
};

export default Row;
